import { X, Info } from 'lucide-react';

interface RightSidebarProps {
  collapsed: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
}

export function RightSidebar({ collapsed, onClose, title = 'Detail', children }: RightSidebarProps) {
  return (
    <aside className={`sidebar-right ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-right-header">
        <h3 className="sidebar-right-title">{title}</h3>
        <button className="sidebar-right-close" onClick={onClose} title="Tutup">
          <X size={18} />
        </button>
      </div>
      <div className="sidebar-right-body">
        {children || (
          <div className="sidebar-detail-empty">
            <Info size={48} className="sidebar-detail-empty-icon" />
            <p>Pilih item untuk melihat detail</p>
          </div>
        )}
      </div>
    </aside>
  );
}
